import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import LoggedInUserApi from "../../api/LoggedInUserApi";
import { ILoggedInUserRoot } from "../../config/interfaces";
import UtilService from "../../services/UtilService";
import { RootState } from "../Store";

interface UserState {
	loggedInUser: ILoggedInUserRoot | null;
}

const initialState: UserState = {
	loggedInUser: null
};

const LoggedInUserSlice = createSlice({
	name: "loggedInUserSlice",
	initialState,
	reducers: {
		setLoggedInUser: (state, action: PayloadAction<ILoggedInUserRoot>) => {
			state.loggedInUser = action.payload;
		},
		unsetLoggedInUser: (state) => {
			state.loggedInUser = null;
		},
		logout: () => {}
	},
	extraReducers: (builder) => {
		builder.addCase(
			fetchLoggedInUser.fulfilled,
			(state, { payload }: PayloadAction<ILoggedInUserRoot>) => {
				state.loggedInUser = payload;
			}
		);
	}
});

export const fetchLoggedInUser = createAsyncThunk<ILoggedInUserRoot>(
	"loggedInUser/fetchMyProfile",
	async (_, { rejectWithValue }) => {
		try {
			const api = LoggedInUserApi.getInstance();
			const profileResp = await api.getMyProfile();
			return profileResp;
		} catch (error: any) {
			console.log(UtilService.getErrorMessage(error));
			return rejectWithValue(error.response.data);
		}
	}
);

export const { setLoggedInUser, unsetLoggedInUser, logout } = LoggedInUserSlice.actions;

export const loggedInUserSelector = (rootState: RootState) => rootState.loggedInUserReducer;

export default LoggedInUserSlice.reducer;
